import type SecondaryReadingPaneTabData from "../store/schema/SecondaryReadingPaneTabData";
import type TabViewState from "../store/schema/TabViewState";
import { TabType } from "../store/schema/TabViewState";
import { getStore } from "../store/tabStore";

export default function findSecondaryTabById(id: string): TabViewState | null {
    const store = getStore();
    for (const tab of store.tabs) {
        if (tab.type !== TabType.Primary &&
            tab.type !== TabType.SxS &&
            tab.type !== TabType.Reminders &&
            tab.type !== TabType.AddCalendars &&
            (tab.data as SecondaryReadingPaneTabData)?.id?.Id == id) {
            return tab;
        }
    }
    
    return null;
}
